// Form options for Member Registration Page

export const prefixOptions = [
    "Mr.",
    "Mrs.",
    "Ms.",
    "Miss",
    "Dr.",
    "Prof.",
    "Rev. (Reverend)",
    "Hon. (Honorable)",
    "Fr. (Father)",
    "Sr. (Sister)",
    "Other",
];

export const suffixOptions = [
    "Jr.",
    "Sr.",
    "II",
    "III",
    "IV",
    "V",
    "Esq.",
    "MD",
    "JD",
    "PhD",
    "Other",
];

export const genderOptions = ["Male", "Female", "Other"];

export const industryOptions = [
    "Agriculture / Farming",
    "Arts / Entertainment / Media",
    "Construction / Skilled Trades",
    "Education / Training",
    "Energy / Utilities",
    "Financial Services / Banking / Insurance",
    "Government / Public Sector",
    "Healthcare / Medical Services",
    "Hospitality / Tourism / Food Services",
    "Information Technology / Software / Internet",
    "Legal / Law",
    "Manufacturing / Production",
    "Nonprofit / NGO / Social Services",
    "Real Estate / Property",
    "Retail / Consumer Goods",
    "Science / Research / Laboratory",
    "Telecommunications",
    "Transportation / Logistics",
    "Other",
];

export const govIdTypeOptions = [
    "Social Security Number (SSN)",
    "Driver's License",
    "State ID Card",
    "Passport",
    "Military ID / Common Access Card (CAC)",
    "Permanent Resident Card (Green Card)",
    "Voter Registration Card",
    "Tribal ID / Native American Identification",
    "Alien Registration Number (A-Number)",
    "Employment Authorization Document (EAD)",
    "Passport Card",
    "Certificate of Naturalization",
    "Other",
];

export const educationOptions = [
    "High School Diploma / GED",
    "Vocational / Technical Certificate",
    "Associate of Arts (AA)",
    "Associate of Science (AS)",
    "Associate of Applied Science (AAS)",
    "Bachelor of Arts (BA)",
    "Bachelor of Science (BS)",
    "Bachelor of Fine Arts (BFA)",
    "Bachelor of Business Administration (BBA)",
    "Bachelor of Engineering (BE / BEng)",
    "Bachelor of Technology (BTech)",
    "Master of Arts (MA)",
    "Master of Science (MS / MSc)",
    "Master of Business Administration (MBA)",
    "Master of Education (MEd)",
    "Master of Fine Arts (MFA)",
    "Master of Engineering (MEng)",
    "Master of Public Health (MPH)",
    "Master of Social Work (MSW)",
    "Doctor of Philosophy (PhD)",
    "Doctor of Education (EdD)",
    "Doctor of Medicine (MD)",
    "Doctor of Osteopathy (DO)",
    "Doctor of Dental Surgery (DDS)",
    "Doctor of Dental Medicine (DMD)",
    "Doctor of Veterinary Medicine (DVM)",
    "Juris Doctor (JD)",
    "Doctor of Nursing Practice (DNP)",
    "Professional Certifications (CPA, PE, RN, etc.)",
    "Postgraduate Diploma / Certificate",
    "Other",
];

export const skillsOptions = [
    // Skills
    "Administration / Office Support",
    "Accounting / Bookkeeping / Finance",
    "Fundraising / Grant Writing",
    "Project Management",
    "Event Planning / Coordination",
    "Teaching / Tutoring / Mentoring",
    "Coaching / Training",
    "Legal / Policy / Compliance",
    "Communication / Public Speaking",
    "Marketing / Social Media / Outreach",
    "IT / Web Development / Software",
    "Data Analysis / Research",
    "Translation / Interpretation",
    "Healthcare / First Aid / Medical Assistance",
    "Photography / Videography / Graphic Design",
    "Volunteer Coordination / Team Leadership",
    "Writing / Content Creation",
    "Technical / Trade Skills (Electrician, Carpenter, etc.)",
    // Interests
    "Animal Welfare / Rescue",
    "Children / Youth Programs",
    "Education / Literacy / Tutoring",
    "Environment / Conservation",
    "Health & Wellness / Public Health",
    "Homelessness / Housing",
    "Human Rights / Civil Rights",
    "Seniors / Elderly Care",
    "Arts & Culture / Performing Arts",
    "Disaster Relief / Emergency Response",
    "Food Security / Hunger Relief",
    "Women's Empowerment / Gender Equality",
    "Sports & Recreation",
    "Technology / STEM Outreach",
    "Volunteering / Community Service",
    "Other",
];
